import React, { useState } from 'react';
import shortid from 'shortid';
import PropTypes, { shape } from 'prop-types';
import {
  ListStyled,
  ListLinkStyled,
  ItemHeaderStyled,
  ItemContainer,
  PhoneGroupStyled,
  ContactNumberStyled,
  WhatsappIconStyled,
  ItemTitleStyled,
  ContactTitleStyled,
} from './styles/ItemListStyled';
import { PlusSignIcon, PhoneIcon } from '../../../images/footer';
import { redirectInternalOrExternal } from '../../../helpers/Redirect';

const ItemList = ({ title, tag, data }) => {
  const [active, setActive] = useState(false);

  if (tag === 'contact') {
    return (
      <ItemContainer tag={tag}>
        <ItemHeaderStyled>
          <ContactTitleStyled>{title}</ContactTitleStyled>
        </ItemHeaderStyled>

        <PhoneGroupStyled>
          <h4>Escríbenos a nuestro WhatsApp</h4>
          <ContactNumberStyled>
            <WhatsappIconStyled />
            <a
              href="https://wa.me/56935223070"
              target="_blank"
              rel="noreferrer"
            >
              +56 9 3522 3070
            </a>
          </ContactNumberStyled>
        </PhoneGroupStyled>

        <PhoneGroupStyled>
          <h4>Pórtate llamando al</h4>
          <ContactNumberStyled phoneColor="#2383DE">
            <PhoneIcon />
            <a href="tel:+223377600">22 3377 600</a>
          </ContactNumberStyled>
        </PhoneGroupStyled>

        <PhoneGroupStyled>
          <h4>Marca desde tu celular</h4>
          <ContactNumberStyled phoneColor="#e62771">
            <PhoneIcon />
            <a href="tel:+103">103</a>
          </ContactNumberStyled>
        </PhoneGroupStyled>
      </ItemContainer>
    );
  }

  return (
    <ItemContainer active={active} tag={tag}>
      <ItemHeaderStyled onClick={() => setActive(!active)}>
        <ItemTitleStyled>{title}</ItemTitleStyled>
        <PlusSignIcon />
      </ItemHeaderStyled>

      <ListStyled>
        {data.map(item => (
          <li key={shortid.generate()}>
            <ListLinkStyled
              alt={item.label}
              onClick={() => redirectInternalOrExternal(item.url)}
            >
              {item.label}
            </ListLinkStyled>
          </li>
        ))}
      </ListStyled>
    </ItemContainer>
  );
};

ItemList.defaultProps = {
  data: [{ label: '', url: '' }],
};

ItemList.propTypes = {
  title: PropTypes.string.isRequired,
  tag: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    shape({
      label: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })
  ),
};

export default ItemList;
